import styles from "./CenteredSpinner.module.css";
import { Spinner } from "@postenbring/hedwig-react";

export function CenteredSpinner() {
  return (
    <div className={styles.spinnerContainer}>
      <Spinner size={"large"} />
    </div>
  );
}
